import { ROUTES } from '@/constants/routes';
import {
  roleHasCapability,
  sidebarItemCapability,
} from './capabilities';
import type { AdminRoute, SidebarItem, UserRole } from './types';

const UNIT1_STAFF_ROLES: UserRole[] = ['ceo', 'support', 'manager'];

const SIDEBAR_ITEM_TO_ROUTE: Record<SidebarItem, AdminRoute> = {
  dashboard: ROUTES.DASHBOARD,
  users: ROUTES.USERS,
  logs: ROUTES.LOGS,
  staff: ROUTES.STAFF,
};

const ROUTE_TO_SIDEBAR_ITEM = Object.fromEntries(
  Object.entries(SIDEBAR_ITEM_TO_ROUTE).map(([item, route]) => [route, item]),
) as Record<AdminRoute, SidebarItem>;

const ADMIN_ROUTES = new Set<string>(Object.values(SIDEBAR_ITEM_TO_ROUTE));

export function hasAdminWebAccess(role: UserRole): boolean {
  return UNIT1_STAFF_ROLES.includes(role);
}

export function isCeoRole(role: UserRole): boolean {
  return role === 'ceo';
}

export function canSeeSidebarItem(role: UserRole, item: SidebarItem): boolean {
  if (!hasAdminWebAccess(role)) return false;
  return roleHasCapability(role, sidebarItemCapability(item));
}

export function canAccessRoute(role: UserRole, route: string): boolean {
  if (!hasAdminWebAccess(role)) return false;
  if (!ADMIN_ROUTES.has(route)) return true;

  const sidebarItem = ROUTE_TO_SIDEBAR_ITEM[route as AdminRoute];
  if (!sidebarItem) return false;

  return canSeeSidebarItem(role, sidebarItem);
}

export function pathToSidebarItem(path: string): SidebarItem | null {
  return ROUTE_TO_SIDEBAR_ITEM[path as AdminRoute] ?? null;
}
